import React, { Component } from 'react';
import { RandomGoodNews } from './Components/RandomGoodNews';
import { getRandomInt } from './Utils/Utils';
import { colors } from './Utils/Colors';
import './App.css';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-167324374-1');
ReactGA.pageview('/home');

interface AppState {
  color: string;
}

class App extends Component<{}, AppState> {
  constructor(props: any) {
    super(props)
    this.state = {
        color: colors[getRandomInt(colors.length)],
    }
    this.updateBackgroundColor = this.updateBackgroundColor.bind(this)
  }

  updateBackgroundColor() {
    this.setState({ color: colors[getRandomInt(colors.length)]});
  }

  render() {
    const { color } = this.state;
    return (
      <div className="App" style={{backgroundColor: `${color}`}}>
        <div className="App-title">
          <p>Random Good News about COVID-19</p>
        </div>
        <div className="App-content">
            <RandomGoodNews updateBackgroundColor={this.updateBackgroundColor}/>
        </div>
      </div>
    );
  }
}

export default App;
